/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `single` - Intrare unică
 * * `multiple` - Intrare multiplă
 */
export enum EntryTypeEnum {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
